import { Component, OnInit } from '@angular/core';
import { ServicioFirebaseService } from 'src/app/servicios/servicio-firebase.service';
///variable de jquey para modal//
declare var $: any;
@Component({
  selector: 'app-accesoactividad',
  templateUrl: './accesoactividad.component.html',
  styleUrls: ['./accesoactividad.component.css']
})
export class AccesoactividadComponent implements OnInit {
  public clave: string = "";
  public noExiste: Boolean;
  constructor(private servicio: ServicioFirebaseService) { }

  ngOnInit() {
  }
  accederActividad() {
    if (this.clave == "") {
      this.noExiste = true;
    } else {
      this.servicio.accederActividad(this.clave).then(res => {
        if (res == "no existe") {
          this.noExiste = true;
        }
      })
    }


  }
}
